import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SiteToolbarComponent } from '../../nav/site-toolbar/site-toolbar.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-landing',  
  imports: [RouterModule, SiteToolbarComponent, MatButtonModule],
  templateUrl: './landing.html',
  styleUrl: './landing.scss',
})
export class Landing {
  appUrl = '/postcards/create';

}
